import styled from 'styled-components';
import { colors } from 'settings/style';

export const Card = styled.section`
  background: #fff;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);

  &:not(:first-child) {
    margin-top: 16px;
  }
`;

export const SideTitle = styled.h4`
  margin: 0 0 14px;
  font-size: 22px;
  line-height: 1.15;
  font-weight: 500;
  font-family: 'Cormorant Garamond', Georgia, serif;
  color: ${colors.grey900};
`;

export const SideHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > h4 {
    margin-bottom: 4px;
  }
`;

export const MetaLine = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #667085;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
`;

export const HeaderActionSlot = styled.div`
  flex-shrink: 0;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f9fafb;
  border-radius: 10px;
  padding: 10px 12px;
  border: 1px solid #f2f4f7;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.2);
`;

export const Text = styled.div`
  min-width: 0;
`;

export const Name = styled.div`
  color: ${colors.grey900};
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Subtitle = styled.div`
  font-size: 11px;
  color: #667085;
`;

export const ToggleButton = styled.button`
  margin-top: 12px;
  width: 100%;
  padding: 9px 12px;
  background: #fff;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: ${colors.primary400};
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover,
  &:focus-visible {
    background: #f9fafb;
    border-color: ${colors.primary300};
  }
`;
